export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '联营商品清单详情',
  dynamicParam: '/:mode/:unitizationId?',
} as TCommon.RouteConfig
